/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const RulesParagraph = styled("div")({
    marginTop: 0,
    marginBottom: "0.3em",
});
